<template>
  <div>
    <div class="tab-view-business-cases">
      <div class="business-cases-table">
        <div class="table-header">
          <div class="table-header-item">{{ t('result_view.business_cases.type') }}</div>
          <div class="table-header-item">{{ t('result_view.business_cases.amount') }}</div>
        </div>
        <!-- Record Types -->
        <div class="table-entry" 
          :class="{ 'disabled': dataStore.amountofRecords === 0 }"
          @click="dataStore.recordtypesopen = !dataStore.recordtypesopen">
          <div class="table-entry-type">
            <div class="table-entry-type-text">Record Types</div>
          </div>
          <div class="table-entry-type">{{ dataStore.amountofRecords }}</div>
          <div v-if="dataStore.amountofRecords > 0" 
            class="icon-div"
            :class="{ 'up': dataStore.recordtypesopen, 'down': !dataStore.recordtypesopen }">
          </div>
        </div>
        <div class="table-entry-items" v-if="dataStore.recordtypesopen">
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.recordCounts.open > 0, 'red-background': dataStore.recordCounts.open == 0 }">
            <div :class="{ 'right': dataStore.recordCounts.open > 0, 'false': dataStore.recordCounts.open == 0 }"></div>
            <div> open {{ "(" + dataStore.recordCounts.open + ")" }}</div>
          </div>
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.recordCounts.perkey > 0, 'red-background': dataStore.recordCounts.perkey == 0 }">
            <div :class="{ 'right': dataStore.recordCounts.perkey > 0, 'false': dataStore.recordCounts.perkey == 0 }"></div>
            <div>Periodkey (perkey) {{ "(" + dataStore.recordCounts.perkey + ")" }}</div>
          </div>
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.recordCounts.log > 0, 'red-background': dataStore.recordCounts.log == 0 }">
            <div :class="{ 'right': dataStore.recordCounts.log > 0, 'false': dataStore.recordCounts.log == 0 }"></div>
            <div>log {{ "(" + dataStore.recordCounts.log + ")" }}</div>
          </div>
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.recordCounts.Cfg > 0, 'red-background': dataStore.recordCounts.Cfg == 0 }">
            <div :class="{ 'right': dataStore.recordCounts.Cfg > 0, 'false': dataStore.recordCounts.Cfg == 0 }"></div>
            <div>Configuration (Cfg) {{ "(" + dataStore.recordCounts.Cfg + ")" }}</div>
          </div>
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.recordCounts.TraS > 0, 'red-background': dataStore.recordCounts.TraS == 0 }">
            <div :class="{ 'right': dataStore.recordCounts.TraS > 0, 'false': dataStore.recordCounts.TraS == 0 }"></div>
            <div>Transaction Start (TraS) {{ "(" + dataStore.recordCounts.TraS + ")" }}</div>
          </div>
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.recordCounts.Tra > 0, 'red-background': dataStore.recordCounts.Tra == 0 }">
            <div :class="{ 'right': dataStore.recordCounts.Tra > 0, 'false': dataStore.recordCounts.Tra == 0 }"></div>
            <div>Transaction (Tra) {{ "(" + dataStore.recordCounts.Tra + ")" }}</div>
          </div>
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.recordCounts.rep > 0, 'red-background': dataStore.recordCounts.rep == 0 }">
            <div :class="{ 'right': dataStore.recordCounts.rep > 0, 'false': dataStore.recordCounts.rep == 0 }"></div>
            <div>Report (rep) {{ "(" + dataStore.recordCounts.rep + ")" }}</div>
          </div>
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.recordCounts.audit > 0, 'red-background': dataStore.recordCounts.audit == 0 }">
            <div :class="{ 'right': dataStore.recordCounts.audit > 0, 'false': dataStore.recordCounts.audit == 0 }"></div>
            <div>Intern Audit (audit) {{ "(" + dataStore.recordCounts.audit + ")" }}</div>
          </div>
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.recordCounts.Audit > 0, 'red-background': dataStore.recordCounts.Audit == 0 }">
            <div :class="{ 'right': dataStore.recordCounts.Audit > 0, 'false': dataStore.recordCounts.Audit == 0 }"></div>
            <div>Extern Audit (Audit) {{ "(" + dataStore.recordCounts.Audit + ")" }}</div>
          </div>
        </div>

        <!-- Business Cases -->
        <div class="table-entry" :class="{ 'disabled': dataStore.amountofBC === 0 }"
          @click="dataStore.businesscaseopen = !dataStore.businesscaseopen">
          <div class="table-entry-type">
            <div class="table-entry-type-text">Business Cases</div>
          </div>
          <div class="table-entry-type">{{ dataStore.amountofBC }}</div>
          <div v-if="dataStore.amountofBC > 0" class="icon-div"
            :class="{ 'up': dataStore.businesscaseopen, 'down': !dataStore.businesscaseopen }">
          </div>
        </div>
        <div class="table-entry-items" v-if="dataStore.businesscaseopen">
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.businessCases.Void.a > 0, 'red-background': dataStore.businessCases.Void.a == 0 }">
            <div :class="{ 'right': dataStore.businessCases.Void.a > 0, 'false': dataStore.businessCases.Void.a == 0 }"></div>
            <div v-if="dataStore.businessCases.Void.a > 0">Void {{ "(" + dataStore.businessCases.Void.a + ", errors: " + dataStore.businessCases.Void.e + ", warnings: " + dataStore.businessCases.Void.w + ")" }}</div>
            <div v-else>Void (0)</div>
          </div>
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.businessCases.Z.a > 0, 'red-background': dataStore.businessCases.Z.a == 0 }">
            <div :class="{ 'right': dataStore.businessCases.Z.a > 0, 'false': dataStore.businessCases.Z.a == 0 }"> </div>
            <div v-if="dataStore.businessCases.Z.a > 0">Z {{ "(" + dataStore.businessCases.Z.a + ", error: " + dataStore.businessCases.Z.e + ", warning: " + dataStore.businessCases.Z.w + ")" }}</div>
            <div v-else>Z (0)</div>
          </div>
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.businessCases.X.a > 0, 'red-background': dataStore.businessCases.X.a == 0 }">
            <div :class="{ 'right': dataStore.businessCases.X.a > 0, 'false': dataStore.businessCases.X.a == 0 }"> </div>
            <div v-if="dataStore.businessCases.X.a > 0">X {{ "(" + dataStore.businessCases.X.a + ", error: " + dataStore.businessCases.X.e + ", warning: " + dataStore.businessCases.X.w + ")" }}</div>
            <div v-else>X (0)</div>
          </div>
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.businessCases.Training.a > 0, 'red-background': dataStore.businessCases.Training.a == 0 }">
            <div
              :class="{ 'right': dataStore.businessCases.Training.a > 0, 'false': dataStore.businessCases.Training.a == 0 }">
            </div>
            <div v-if="dataStore.businessCases.Training.a > 0">Training {{ "(" + dataStore.businessCases.Training.a + ", error: " + dataStore.businessCases.Training.e + ", warning: " + dataStore.businessCases.Training.w + ")" }}</div>
            <div v-else>Training (0)</div>
          </div>
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.businessCases.NonFiscalInvoice.a > 0, 'red-background': dataStore.businessCases.NonFiscalInvoice.a == 0 }">
            <div
              :class="{ 'right': dataStore.businessCases.NonFiscalInvoice.a > 0, 'false': dataStore.businessCases.NonFiscalInvoice.a == 0 }">
            </div>
            <div v-if="dataStore.businessCases.NonFiscalInvoice.a > 0">NonFiscalInvoice {{ "(" + dataStore.businessCases.NonFiscalInvoice.a + ", error: " + dataStore.businessCases.NonFiscalInvoice.e + ", warning: " + dataStore.businessCases.NonFiscalInvoice.w + ")" }}</div>
            <div v-else>NonFiscalInvoice (0)</div>
          </div>
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.businessCases.FiscalInvoice.a > 0, 'red-background': dataStore.businessCases.FiscalInvoice.a == 0 }">
            <div
              :class="{ 'right': dataStore.businessCases.FiscalInvoice.a > 0, 'false': dataStore.businessCases.FiscalInvoice.a == 0 }">
            </div>
            <div v-if="dataStore.businessCases.FiscalInvoice.a > 0">FiscalInvoice {{ "(" + dataStore.businessCases.FiscalInvoice.a + ", error: " + dataStore.businessCases.FiscalInvoice.e + ", warning: " + dataStore.businessCases.FiscalInvoice.w + ")" }}</div>
            <div v-else>FiscalInvoice (0)</div>
          </div>
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.businessCases.Abort.a > 0, 'red-background': dataStore.businessCases.Abort.a == 0 }">
            <div :class="{ 'right': dataStore.businessCases.Abort.a > 0, 'false': dataStore.businessCases.Abort.a == 0 }">
            </div>
            <div v-if="dataStore.businessCases.Abort.a > 0">Abort {{ "(" + dataStore.businessCases.Abort.a + ", error: " + dataStore.businessCases.Abort.e + ", warning: " + dataStore.businessCases.Abort.w + ")" }}</div>
            <div v-else>Abort (0)</div>
          </div>
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.businessCases.Order.a > 0, 'red-background': dataStore.businessCases.Order.a == 0 }">
            <div :class="{ 'right': dataStore.businessCases.Order.a > 0, 'false': dataStore.businessCases.Order.a == 0 }">
            </div>
            <div v-if="dataStore.businessCases.Order.a > 0">Order {{ "(" + dataStore.businessCases.Order.a + ", error: " + dataStore.businessCases.Order.e + ", warning: " + dataStore.businessCases.Order.w + ")" }}</div>
            <div v-else>Order (0)</div>
          </div>
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.businessCases.OpeningBalance.a > 0, 'red-background': dataStore.businessCases.OpeningBalance.a == 0 }">
            <div
              :class="{ 'right': dataStore.businessCases.OpeningBalance.a > 0, 'false': dataStore.businessCases.OpeningBalance.a == 0 }">
            </div>
            <div v-if="dataStore.businessCases.OpeningBalance.a > 0">OpeningBalance {{ "(" + dataStore.businessCases.OpeningBalance.a + ", error: " + dataStore.businessCases.OpeningBalance.e + ", warning: " + dataStore.businessCases.OpeningBalance.w + ")" }}</div>
            <div v-else>OpeningBalance (0)</div>
          </div>
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.businessCases.DepositOfChange.a > 0, 'red-background': dataStore.businessCases.DepositOfChange.a == 0 }">
            <div
              :class="{ 'right': dataStore.businessCases.DepositOfChange.a > 0, 'false': dataStore.businessCases.DepositOfChange.a == 0 }">
            </div>
            <div v-if="dataStore.businessCases.DepositOfChange.a > 0">DepositOfChange {{ "(" + dataStore.businessCases.DepositOfChange.a + ", error: " + dataStore.businessCases.DepositOfChange.e + ", warning: " + dataStore.businessCases.DepositOfChange.w + ")" }}</div>
            <div v-else>DepositOfChange (0)</div>
          </div>
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.businessCases.DailyClosureCashout.a > 0, 'red-background': dataStore.businessCases.DailyClosureCashout.a == 0 }">
            <div
              :class="{ 'right': dataStore.businessCases.DailyClosureCashout.a > 0, 'false': dataStore.businessCases.DailyClosureCashout.a == 0 }">
            </div>
            <div v-if="dataStore.businessCases.DailyClosureCashout.a > 0">DailyClosureCashout {{ "(" + dataStore.businessCases.DailyClosureCashout.a + ", error: " + dataStore.businessCases.DailyClosureCashout.e + ", warning: " + dataStore.businessCases.DailyClosureCashout.w + ")" }}</div>
            <div v-else>DailyClosureCashout (0)</div>
          </div>
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.businessCases.PayIn.a > 0, 'red-background': dataStore.businessCases.PayIn.a == 0 }">
            <div :class="{ 'right': dataStore.businessCases.PayIn.a > 0, 'false': dataStore.businessCases.PayIn.a == 0 }">
            </div>
            <div v-if="dataStore.businessCases.PayIn.a > 0">PayIn {{ "(" + dataStore.businessCases.PayIn.a + ", error: " + dataStore.businessCases.PayIn.e + ", warning: " + dataStore.businessCases.PayIn.w + ")" }}</div>
            <div v-else>PayIn (0)</div>
          </div>
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.businessCases.PayOut.a > 0, 'red-background': dataStore.businessCases.PayOut.a == 0 }">
            <div
              :class="{ 'right': dataStore.businessCases.PayOut.a > 0, 'false': dataStore.businessCases.PayOut.a == 0 }">
            </div>
            <div v-if="dataStore.businessCases.PayOut.a > 0">PayOut {{ "(" + dataStore.businessCases.PayOut.a + ", error: " + dataStore.businessCases.PayOut.e + ", warning: " + dataStore.businessCases.PayOut.w + ")" }}</div>
            <div v-else>PayOut (0)</div>
          </div>
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.businessCases.Reprint.a > 0, 'red-background': dataStore.businessCases.Reprint.a == 0 }">
            <div
              :class="{ 'right': dataStore.businessCases.Reprint.a > 0, 'false': dataStore.businessCases.Reprint.a == 0 }">
            </div>
            <div v-if="dataStore.businessCases.Reprint.a > 0">Reprint {{ "(" + dataStore.businessCases.Reprint.a + ", error: " + dataStore.businessCases.Reprint.e + ", warning: " + dataStore.businessCases.Reprint.w + ")" }}</div>
            <div v-else>Reprint (0)</div>
          </div>
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.businessCases.Login.a > 0, 'red-background': dataStore.businessCases.Login.a == 0 }">
            <div :class="{ 'right': dataStore.businessCases.Login.a > 0, 'false': dataStore.businessCases.Login.a == 0 }">
            </div>
            <div v-if="dataStore.businessCases.Login.a > 0">Login {{ "(" + dataStore.businessCases.Login.a + ", error: " + dataStore.businessCases.Login.e + ", warning: " + dataStore.businessCases.Login.w + ")" }}</div>
            <div v-else>Login (0)</div>
          </div>
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.businessCases.Logout.a > 0, 'red-background': dataStore.businessCases.Logout.a == 0 }">
            <div
              :class="{ 'right': dataStore.businessCases.Logout.a > 0, 'false': dataStore.businessCases.Logout.a == 0 }">
            </div>
            <div v-if="dataStore.businessCases.Logout.a > 0">Logout {{ "(" + dataStore.businessCases.Logout.a + ", error: " + dataStore.businessCases.Logout.e + ", warning: " + dataStore.businessCases.Logout.w + ")" }}</div>
            <div v-else>Logout (0)</div>
          </div>
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.businessCases.ProformaInvoice.a > 0, 'red-background': dataStore.businessCases.ProformaInvoice.a == 0 }">
            <div
              :class="{ 'right': dataStore.businessCases.ProformaInvoice.a > 0, 'false': dataStore.businessCases.ProformaInvoice.a == 0 }">
            </div>
            <div v-if="dataStore.businessCases.ProformaInvoice.a > 0">ProformaInvoice {{ "(" + dataStore.businessCases.ProformaInvoice.a + ", error: " + dataStore.businessCases.ProformaInvoice.e + ", warning: " + dataStore.businessCases.ProformaInvoice.w + ")" }}</div>
            <div v-else>ProformaInvoice (0)</div>
          </div>
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.businessCases.NonFiscal.a > 0, 'red-background': dataStore.businessCases.NonFiscal.a == 0 }">
            <div
              :class="{ 'right': dataStore.businessCases.NonFiscal.a > 0, 'false': dataStore.businessCases.NonFiscal.a == 0 }">
            </div>
            <div v-if="dataStore.businessCases.NonFiscal.a > 0">NonFiscal {{ "(" + dataStore.businessCases.NonFiscal.a + ", error: " + dataStore.businessCases.NonFiscal.e + ", warning: " + dataStore.businessCases.NonFiscal.w + ")" }}</div>
            <div v-else>NonFiscal (0)</div>
          </div>
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.businessCases.Sale.a > 0, 'red-background': dataStore.businessCases.Sale.a == 0 }">
            <div 
              :class="{ 'right': dataStore.businessCases.Sale.a > 0, 'false': dataStore.businessCases.Sale.a == 0 }">
            </div>
            <div v-if="dataStore.businessCases.Sale.a > 0">Sale {{ "(" + dataStore.businessCases.Sale.a + ", error: " + dataStore.businessCases.Sale.e + ", warning: " + dataStore.businessCases.Sale.w + ")" }}</div>
            <div v-else>Sale (0)</div>
          </div>
        </div>

        <!-- Business Position Types -->
        <div class="table-entry" :class="{ 'disabled': dataStore.amountofBP === 0 }"
          @click="dataStore.businesspositionopen = !dataStore.businesspositionopen">
          <div class="table-entry-type">
            <div class="table-entry-type-text">Business Position Types</div>
          </div>
          <div class="table-entry-type">{{ dataStore.amountofBP }}</div>
          <div v-if="dataStore.amountofBP > 0" class="icon-div"
            :class="{ 'up': dataStore.businesspositionopen, 'down': !dataStore.businesspositionopen }"></div>
        </div>
        <div class="table-entry-items" v-if="dataStore.businesspositionopen">
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.businessPosition.Service > 0, 'red-background': dataStore.businessPosition.Service == 0 }">
            <div
              :class="{ 'right': dataStore.businessPosition.Service > 0, 'false': dataStore.businessPosition.Service == 0 }">
            </div>
            <div> Service {{ "(" + dataStore.businessPosition.Service + ")" }}</div>
          </div>
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.businessPosition.Discount > 0, 'red-background': dataStore.businessPosition.Discount == 0 }">
            <div
              :class="{ 'right': dataStore.businessPosition.Discount > 0, 'false': dataStore.businessPosition.Discount == 0 }">
            </div>
            <div>Discount {{ "(" + dataStore.businessPosition.Discount + ")" }}</div>
          </div>
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.businessPosition.Surcharge > 0, 'red-background': dataStore.businessPosition.Surcharge == 0 }">
            <div
              :class="{ 'right': dataStore.businessPosition.Surcharge > 0, 'false': dataStore.businessPosition.Surcharge == 0 }">
            </div>
            <div>Surcharge {{ "(" + dataStore.businessPosition.Surcharge + ")" }}</div>
          </div>
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.businessPosition.Refund > 0, 'red-background': dataStore.businessPosition.Refund == 0 }">
            <div
              :class="{ 'right': dataStore.businessPosition.Refund > 0, 'false': dataStore.businessPosition.Refund == 0 }">
            </div>
            <div>Refund {{ "(" + dataStore.businessPosition.Refund + ")" }}</div>
          </div>
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.businessPosition.LineVoid > 0, 'red-background': dataStore.businessPosition.LineVoid == 0 }">
            <div
              :class="{ 'right': dataStore.businessPosition.LineVoid > 0, 'false': dataStore.businessPosition.LineVoid == 0 }">
            </div>
            <div>LineVoid {{ "(" + dataStore.businessPosition.LineVoid + ")" }}</div>
          </div>
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.businessPosition.VoucherSale > 0, 'red-background': dataStore.businessPosition.VoucherSale == 0 }">
            <div
              :class="{ 'right': dataStore.businessPosition.VoucherSale > 0, 'false': dataStore.businessPosition.VoucherSale == 0 }">
            </div>
            <div>VoucherSale {{ "(" + dataStore.businessPosition.VoucherSale + ")" }}</div>
          </div>
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.businessPosition.VoucherPayment > 0, 'red-background': dataStore.businessPosition.VoucherPayment == 0 }">
            <div
              :class="{ 'right': dataStore.businessPosition.VoucherPayment > 0, 'false': dataStore.businessPosition.VoucherPayment == 0 }">
            </div>
            <div>VoucherPayment {{ "(" + dataStore.businessPosition.VoucherPayment + ")" }}</div>
          </div>
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.businessPosition.AdvancePaymentSetting > 0, 'red-background': dataStore.businessPosition.AdvancePaymentSetting == 0 }">
            <div
              :class="{ 'right': dataStore.businessPosition.AdvancePaymentSetting > 0, 'false': dataStore.businessPosition.AdvancePaymentSetting == 0 }">
            </div>
            <div>AdvancePaymentSetting {{ "(" + dataStore.businessPosition.AdvancePaymentSetting + ")" }}</div>
          </div>
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.businessPosition.AdvancePaymentResolution > 0, 'red-background': dataStore.businessPosition.AdvancePaymentResolution == 0 }">
            <div
              :class="{ 'right': dataStore.businessPosition.AdvancePaymentResolution > 0, 'false': dataStore.businessPosition.AdvancePaymentResolution == 0 }">
            </div>
            <div>AdvancePaymentResolution {{ "(" + dataStore.businessPosition.AdvancePaymentResolution + ")" }}</div>
          </div>
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.businessPosition.DepositSale > 0, 'red-background': dataStore.businessPosition.DepositSale == 0 }">
            <div
              :class="{ 'right': dataStore.businessPosition.DepositSale > 0, 'false': dataStore.businessPosition.DepositSale == 0 }">
            </div>
            <div>DepositSale {{ "(" + dataStore.businessPosition.DepositSale + ")" }}</div>
          </div>
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.businessPosition.DepositReturn > 0, 'red-background': dataStore.businessPosition.DepositReturn == 0 }">
            <div
              :class="{ 'right': dataStore.businessPosition.DepositReturn > 0, 'false': dataStore.businessPosition.DepositReturn == 0 }">
            </div>
            <div>DepositReturn {{ "(" + dataStore.businessPosition.DepositReturn + ")" }}</div>
          </div>
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.businessPosition.Tip > 0, 'red-background': dataStore.businessPosition.Tip == 0 }">
            <div
              :class="{ 'right': dataStore.businessPosition.Tip > 0, 'false': dataStore.businessPosition.Tip == 0 }">
            </div>
            <div>Tip {{ "(" + dataStore.businessPosition.Tip + ")" }}</div>
          </div>
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.businessPosition.OpeningBalance > 0, 'red-background': dataStore.businessPosition.OpeningBalance == 0 }">
            <div
              :class="{ 'right': dataStore.businessPosition.OpeningBalance > 0, 'false': dataStore.businessPosition.OpeningBalance == 0 }">
            </div>
            <div>OpeningBalance {{ "(" + dataStore.businessPosition.OpeningBalance + ")" }}</div>
          </div>
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.businessPosition.OpeningBalancePayment > 0, 'red-background': dataStore.businessPosition.OpeningBalancePayment == 0 }">
            <div
              :class="{ 'right': dataStore.businessPosition.OpeningBalancePayment > 0, 'false': dataStore.businessPosition.OpeningBalancePayment == 0 }">
            </div>
            <div>OpeningBalancePayment {{ "(" + dataStore.businessPosition.OpeningBalancePayment + ")" }}</div>
          </div>
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.businessPosition.Rounding > 0, 'red-background': dataStore.businessPosition.Rounding == 0 }">
            <div
              :class="{ 'right': dataStore.businessPosition.Rounding > 0, 'false': dataStore.businessPosition.Rounding == 0 }">
            </div>
            <div>Rounding {{ "(" + dataStore.businessPosition.Rounding + ")" }}</div>
          </div>
          <div class="table-entry-item"
            :class="{ 'green-background': dataStore.businessPosition.ForeignCurrency > 0, 'red-background': dataStore.businessPosition.ForeignCurrency == 0 }">
            <div
              :class="{ 'right': dataStore.businessPosition.ForeignCurrency > 0, 'false': dataStore.businessPosition.ForeignCurrency == 0 }">
            </div>
            <div>ForeignCurrency {{ "(" + dataStore.businessPosition.ForeignCurrency + ")" }}</div>
          </div>
        </div>

        <!-- Totals -->
        <div class="table-entry" :class="{ 'disabled': dataStore.amountofBC === 0 }"
          @click="dataStore.totalsopen = !dataStore.totalsopen">
          <div class="table-entry-type">
            <div class="table-entry-type-text">Totals</div>
          </div>
          <div class="table-entry-type">{{ formatCurrency(dataStore.totals.T) }}</div>
          <div v-if="dataStore.amountofBC > 0" class="icon-div"
            :class="{ 'up': dataStore.totalsopen, 'down': !dataStore.totalsopen }"></div>
        </div>
        <div class="table-entry-items" v-if="dataStore.totalsopen">
          <div class="table-entry-item neutral-background totals-item">
            <div class="totals-label">Total Amount</div>
            <div class="totals-value" :class="{ 'negative-amount': dataStore.totals.T < 0 }">{{ formatCurrency(dataStore.totals.T) }}</div>
          </div>
          <div class="table-entry-item neutral-background totals-item">
            <div class="totals-label">Total Amount Fiscal Transactions <span class="totals-note">(without NF &amp; NFS)</span></div>
            <div class="totals-value" :class="{ 'negative-amount': dataStore.totals.FiscalAmount < 0 }">{{ formatCurrency(dataStore.totals.FiscalAmount) }}</div>
          </div>
          <div class="table-entry-item neutral-background totals-item">
            <div class="totals-label">Total Amount Void</div>
            <div class="totals-value" :class="{ 'negative-amount': dataStore.totals.VoidAmount < 0 }">{{ formatCurrency(dataStore.totals.VoidAmount) }}</div>
          </div>
          <div class="table-entry-item neutral-background totals-item">
            <div class="totals-label">Total Amount Refund</div>
            <div class="totals-value" :class="{ 'negative-amount': dataStore.totals.RefundAmount < 0 }">{{ formatCurrency(dataStore.totals.RefundAmount) }}</div>
          </div>
          <div class="table-entry-item neutral-background totals-item">
            <div class="totals-label">Total Amount Non-Fiscal Transactions</div>
            <div class="totals-value" :class="{ 'negative-amount': dataStore.totals.NonFiscalAmount < 0 }">{{ formatCurrency(dataStore.totals.NonFiscalAmount) }}</div>
          </div>
          <div class="table-entry-item neutral-background totals-item">
            <div class="totals-label">Total Amount Invoices</div>
            <div class="totals-value" :class="{ 'negative-amount': dataStore.totals.InvoiceAmount < 0 }">{{ formatCurrency(dataStore.totals.InvoiceAmount) }}</div>
          </div>
          <div class="table-entry-item neutral-background totals-item">
            <div class="totals-label">Total Amount e-Invoices</div>
            <div class="totals-value" :class="{ 'negative-amount': dataStore.totals.EInvoiceAmount < 0 }">{{ formatCurrency(dataStore.totals.EInvoiceAmount) }}</div>
          </div>
          <div class="table-entry-item neutral-background totals-item">
            <div class="totals-label">Count e-Invoices</div>
            <div class="totals-value">{{ dataStore.totals.EInvoiceCount }}</div>
          </div>
          <div class="payg-separator" v-if="Object.keys(dataStore.totals.PayGroups).length"></div>
          <div class="table-entry-item neutral-background totals-item" v-for="(amount, group) in dataStore.totals.PayGroups" :key="group">
            <div class="totals-label">PayG {{ group }}</div>
            <div class="totals-value" :class="{ 'negative-amount': amount < 0 }">{{ formatCurrency(amount) }}</div>
          </div>
        </div>

        <!-- Audits -->
        <div class="table-entry" :class="{ 'disabled': dataStore.amountOfAudits === 0 }"
          @click="dataStore.auditopen = !dataStore.auditopen">
          <div class="table-entry-type">
            <div class="table-entry-type-text">Audits</div>
          </div>
          <div class="table-entry-type">{{ dataStore.amountOfAudits }}</div>
          <div v-if="dataStore.amountOfAudits > 0" class="icon-div"
            :class="{ 'up': dataStore.auditopen, 'down': !dataStore.auditopen }"></div>
        </div>
        <div :class="{ 'table-entry-item-audit': dataStore.auditopen, 'hide': !dataStore.auditopen }"
          v-for="(val, key) in dataStore.Audits" :key="key">
          <div class="table-entry-type">{{ key }}</div>
          <div class="table-entry-type">{{ val }}</div>
        </div>
        
        <!-- Cmp -->
        <div class="table-entry" :class="{ 'disabled': dataStore.amountOfCmp === 0 }"
          @click="dataStore.cmpopen = !dataStore.cmpopen">
          <div class="table-entry-type">
            <div class="table-entry-type-text">Company</div>
          </div>
          <div class="table-entry-type">{{ dataStore.amountOfCmp }}</div>
          <div v-if="dataStore.amountOfCmp > 0" class="icon-div"
            :class="{ 'up': dataStore.cmpopen, 'down': !dataStore.cmpopen }"></div>
        </div>
        <div v-if="dataStore.cmpopen">
          <div v-for="(value, key) in dataStore.cmp" :key="key" class="table-entry-item">
            {{ key }}: {{ value }}
          </div>
        </div>

        <!-- Loc -->
        <div class="table-entry" :class="{ 'disabled': dataStore.amountOfLoc === 0 }"
          @click="dataStore.locopen = !dataStore.locopen">
          <div class="table-entry-type">
            <div class="table-entry-type-text">Location</div>
          </div>
          <div class="table-entry-type">{{ dataStore.amountOfLoc }}</div>
          <div v-if="dataStore.amountOfLoc > 0" class="icon-div"
            :class="{ 'up': dataStore.locopen, 'down': !dataStore.locopen }"></div>
        </div>
        <div v-if="dataStore.locopen">
          <div v-for="(value, key) in dataStore.loc" :key="key" class="table-entry-item">
            {{ key }}: {{ value }}
          </div>
        </div>

        <!-- Trm -->
        <div class="table-entry" :class="{ 'disabled': dataStore.amountOfTrm === 0 }"
          @click="dataStore.trmopen = !dataStore.trmopen">
          <div class="table-entry-type">
            <div class="table-entry-type-text">Terminal</div>
          </div>
          <div class="table-entry-type">{{ dataStore.amountOfTrm }}</div>
          <div v-if="dataStore.amountOfTrm > 0" class="icon-div"
            :class="{ 'up': dataStore.trmopen, 'down': !dataStore.trmopen }"></div>
        </div>
        <div v-if="dataStore.trmopen">
          <div v-for="(value, key) in dataStore.trm" :key="key" class="table-entry-item">
            {{ key }}: {{ value }}
          </div>
        </div>

        <!-- Dev -->
        <div class="table-entry" :class="{ 'disabled': dataStore.amountOfDev === 0 }"
          @click="dataStore.devopen = !dataStore.devopen">
          <div class="table-entry-type">
            <div class="table-entry-type-text">Devices</div>
          </div>
          <div class="table-entry-type">{{ dataStore.amountOfDev }}</div>
          <div v-if="dataStore.amountOfDev > 0" class="icon-div"
            :class="{ 'up': dataStore.devopen, 'down': !dataStore.devopen }"></div>
        </div>
        <div v-if="dataStore.devopen">
          <div v-for="(value, key) in dataStore.dev" :key="key" class="table-entry-item">
            {{ key }}: {{ value }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useDataStore } from '@/stores/dataStore.js'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const dataStore = useDataStore()

function formatCurrency(value) {
  const amount = Number(value) || 0
  // Format as 000.000.000.000,00 (dot thousands separator, comma decimal) + € suffix
  return `${amount.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} \u20AC`
}
</script>

<style scoped>
.business-cases-table {
  width: 100%;
  padding: 20px;
}

.table-header {
  display: flex;
  justify-content: start;
  gap: 30px;
  padding-left: 15px;
}

.table-header-item {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  color: var(--text-primary-color);
  width: 230px;
}

.table-entry {
  font-size: 15px;
  padding-left: 15px;
  height: 42px;
  background: var(--light-grey-background-color);
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  gap: 30px;
  justify-content: start;
  margin: 10px 0;
}

.table-entry.disabled {
  pointer-events: none;
  cursor: not-allowed;
}

.table-entry:has(+ .table-entry-items) {
  margin-bottom: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.table-entry-type {
  display: flex;
  width: 230px;
  flex-direction: column;
  justify-content: center;
  font-size: medium;
}

.table-entry-type-text {
  width: 230px;
}

.table-entry-items {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  margin: 0 0 10px;
  padding: 15px;
  border: 2px solid var(--light-grey-background-color);
  border-top: none;
  border-radius: 0 0 4px 4px;
}

.payg-separator {
  grid-column: 1 / -1;
  height: 8px;
}

.table-entry-item {
  border-radius: 4px;
  padding-left: 15px;
  height: 35px;
  gap: 10px;
  font-size: 15px;
  display: flex;
}

.table-entry-item div {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.totals-item {
  justify-content: space-between;
  align-items: center;
  padding-right: 15px;
}

.totals-item .totals-label {
  display: block;
}

.totals-note {
  font-size: 0.8em;
}

.totals-value {
  white-space: nowrap;
}

.negative-amount {
  color: var(--active-red-text-color);
}

.table-entry-item-audit {
  margin-top: 5px;
  flex: 1;
  border-radius: 4px;
  padding-left: 15px;
  height: 25px;
  gap: 30px;
  font-size: 15px;
  display: flex;
}

@media screen and (max-width: 1700px) {
  .table-entry-items {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media screen and (max-width: 1360px) {
  .table-entry-items {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media screen and (max-width: 630px) {
  .table-entry-items {
    grid-template-columns: repeat(1, 1fr);
  }
}

/** Audit */
.hide {
  display: none;
}

/** Icons and coloring */
.green-background {
  background-color: var(--green-background-color);
}

.red-background {
  background-color: var(--red-background-color);
}

.neutral-background {
  background-color: var(--neutral-background-color);
}

.icon-div {
  display: flex;
  width: 100%;
  justify-content: flex-end;
}

.up {
  height: 100%;
  background-image: var(--up-arrow);
  background-repeat: no-repeat;
  flex: 1, 1, 100%;
  margin-right: 30px;
  background-position: right;
}

.down {
  height: 100%;
  background-image: var(--down-arrow);
  background-repeat: no-repeat;
  background-position: right;
  margin-right: 30px;
  flex: 1, 1, 100%;
}

.right {
  background-image: var(--right-icon-business-cases);
  background-repeat: no-repeat;
  background-position: center;
  width: 20px;
}

.false {
  background-image: var(--false-icon-business-cases);
  background-repeat: no-repeat;
  background-position: center;
  width: 20px;
}
</style>
  